import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { Colors } from "../../helpers/Colors";
import { fontSize } from "../../helpers/fontSize";
import axios from "axios";
import Table_myReservations from "./section/Table_allReservations";
import { format } from "date-fns";
import { Searchbar_useStyles } from "../../useStyles/Searchbar_useStyles";
import { RiSearch2Line } from "react-icons/ri";
import { IoClose } from "react-icons/io5";
import { ax_allReservations } from "../../api/reservation";

const useStyles = makeStyles({
  Reservation: {
    backgroundColor: Colors.primaryExtraLight2,
    width: "auto",
    // height: "100vh",
    overflow: "auto",
    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "@media only screen and (max-Width: 770px) ": {
      padding: "5px 10px",
    },
    // // --------ipad
    "@media (min-width: 770px) and (max-width: 1025px)": {
      padding: "10px 25px",
    },
    // --------desktop
    "@media (min-width: 1025px) and (max-Width: 2560px) ": {
      padding: "10px 25px",
    },
  },
  Content: {
    width: "100%",
    height: "100%",
    // backgroundColor: Colors.primaryExtraLight,
    "& .heading": {
      // padding: "10px 25px",
      fontSize: fontSize.heading,
      fontWeight: 500,
      // --------- from xs(380px) till md(770px)
      "@media only screen and (max-Width: 770px)": {
        fontSize: fontSize.question,
      },
      "@media only screen and (max-Width: 900px)": {
        padding: "0px 0px 0px 0",
      },
    },
    "& .subHeading": {
      padding: "10px 25px",
      fontSize: fontSize.question,
      fontWeight: 400,
    },
    "& .Overall_Date_Con": {
      // backgroundColor: Colors.success,
      // padding: "0px 25px",
      // fontSize: fontSize.heading,
      // fontWeight: 500,
    },
    "& .Overall_Time_Con": {
      // backgroundColor: Colors.grey,
    },
  },
});

const AllReservations = ({ user, triggerUseEffect, setUseEffect }) => {
  const classes = useStyles();
  const Searchbar_Classes = Searchbar_useStyles();
  const [allReservations, setAllReservations] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  const HandleSearchbar = (e) => {
    e.preventDefault();

    // searchValue = e.target.value;
    setSearchValue(e.target.value);
    const newFilter = allReservations.filter(
      (item) =>
        item.cabinName.cabinName
          .toLowerCase()
          .includes(searchValue.toLowerCase()) ||
        item.email.toLowerCase().includes(searchValue.toLowerCase()) ||
        item._id.toLowerCase().includes(searchValue.toLowerCase()) ||
        format(new Date(item.day), "dd/MM/yyyy")
          .toLowerCase()
          .includes(searchValue.toLowerCase())
    );
    searchValue === "" ? setFilteredData([]) : setFilteredData(newFilter);
  };

  useEffect(() => {
    const ax_fetch = async () => {
      try {
        const ax = await ax_allReservations();
        console.log("ax --> :", ax);
        if (ax.code === 200) {
          setAllReservations(ax.data);
          setUseEffect(true);
        }
      } catch (e) {
        console.log(e);
      }
    };
    ax_fetch();
  }, [triggerUseEffect, showEditModal]);

  return (
    <main
      className={`${classes.Reservation}`}
      style={{ height: "calc(100vh - 58px)" }}
    >
      <section
        // className={`${classes.Content} max-w-md px-4 mx-auto sm:px-7 md:max-w-4xl md:px-6`}
        className={`${classes.Content} `}
        // max-w-md px-4 mx-auto sm:px-7 md:max-w-4xl md:px-6
      >
        <section className="p-2 900px:px-0 900px:py-2 flex items-center justify-between">
          <div className="heading">
            All Reservations - ({allReservations.length})
          </div>
          {/* <div className="subHeading">
            Total Reservations -{" "}
            <span className="text-secondary">{allReservations.length}</span>
          </div> */}
          {/* SearchBar & Filter */}
          <div className={Searchbar_Classes.SearchBar}>
            <main className="Container">
              {/* {JSON.stringify(searchValue)} */}
              <div>
                <input
                  type={"text"}
                  className=""
                  value={searchValue}
                  onChange={HandleSearchbar}
                />
              </div>
              <div className="iconCon">
                {searchValue.length > 0 ? (
                  <IoClose
                    className="icon"
                    id="closeIcon"
                    onClick={() => {
                      setSearchValue("");
                    }}
                  />
                ) : (
                  <RiSearch2Line className="icon" />
                )}
              </div>
            </main>
            <main></main>
          </div>
        </section>

        <div className="Overall_Date_Con">
          <Table_myReservations
            // searchValue={searchValue}
            filteredData={filteredData}
            allReservations={allReservations}
            showEditModal={showEditModal}
            setShowEditModal={setShowEditModal}
            showCancelModal={showCancelModal}
            setShowCancelModal={setShowCancelModal}
            triggerUseEffect={triggerUseEffect}
            setUseEffect={setUseEffect}
          />
        </div>
      </section>
    </main>
  );
};

export default AllReservations;
